<div class="flex items-center justify-start gap-4 mb-6">
  <h2 class="text-xl font-semibold">Dati Contraente</h2>
  <button
    class="bg-blue-600 text-white font-semibold px-4 py-2 rounded shadow hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="avantiStep()"
    [disabled]="!isValid()"
  >
    Avanti >>
  </button>
</div>

<div class="mb-6">
  <p>Compila tutti i campi obbligatori per intestare la tua polizza e clicca sul tasto "Avanti".</p>
</div>

<!-- Dati Azienda -->
<div class="border border-gray-300 rounded-lg shadow p-6 bg-white mb-6">
  <h3 class="text-lg font-semibold mb-4">Dati Azienda</h3>
  <div class="grid md:grid-cols-3 gap-4">
    <div>
      <label class="block mb-1 font-medium">Ragione Sociale *</label>
      <input type="text" [(ngModel)]="ragioneSociale" name="ragioneSociale" #ragioneSocialeRef="ngModel" required
              [class.border-red-500]="ragioneSocialeRef.invalid && ragioneSocialeRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="ragioneSocialeRef.invalid && ragioneSocialeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Tipo Azienda *</label>
      <select [(ngModel)]="tipoAzienda" name="tipoAzienda" #tipoAziendaRef="ngModel" required
              [class.border-red-500]="tipoAziendaRef.invalid && tipoAziendaRef.touched"
              class="w-full border rounded px-3 py-2">
        <option *ngFor="let tipo of tipiAzienda" [value]="tipo">{{ tipo }}</option>
      </select>
      <p *ngIf="tipoAziendaRef.invalid && tipoAziendaRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Partita IVA *</label>
      <input type="text" [(ngModel)]="partitaIva" 
                name="partitaIva" 
                #partitaIvaRef="ngModel" 
                required minlength="10" 
                maxlength="20"
                pattern="^[0-9]{11}$"
                [class.border-red-500]="partitaIvaRef.invalid && partitaIvaRef.touched"
                class="w-full border rounded px-3 py-2" />
      <p *ngIf="partitaIvaRef.invalid && partitaIvaRef.touched" class="text-red-500 text-sm">
        Partita IVA non valida
      </p>
    </div>
  </div>

  <div class="mt-4">
    <label class="block mb-1 font-medium">Indirizzo Sede Legale *</label>
    <input type="text" id="autocompleteAzienda" 
            name="indirizzoCompletoAzienda" 
            [(ngModel)]="indirizzoCompletoAzienda" 
            #indirizzoCompletoAziendaRef="ngModel" 
            required
            [class.border-red-500]="!isValidIndirizzoAzienda() && indirizzoCompletoAziendaRef.touched"
            placeholder="Via civico e città..." class="w-full border rounded px-3 py-2" />
    <p *ngIf="!isValidIndirizzoAzienda() && indirizzoCompletoAziendaRef.touched" class="text-sm text-red-500 mt-1">
      Inserire l'indirizzo completo di via, civico e città
    </p>
  </div>
</div>

<!-- Rappresentante Legale -->
<div class="border border-gray-300 rounded-lg shadow p-6 bg-white">
  <h3 class="text-lg font-semibold mb-4">Rappresentante legale</h3>

  <div class="grid md:grid-cols-3 gap-4">
    <div>
      <label class="block mb-1 font-medium">Codice Fiscale *</label>
      <input type="text" [(ngModel)]="codiceFiscale" 
              name="codiceFiscale" 
              #codiceFiscaleRef="ngModel" 
              required
              minlength="12"
              maxlength="20"
              pattern="^[A-Z0-9]{16}$"
              (input)="codiceFiscale = codiceFiscale.toUpperCase()"
              [class.border-red-500]="codiceFiscaleRef.invalid && codiceFiscaleRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="codiceFiscaleRef.invalid && codiceFiscaleRef.touched" class="text-sm text-red-500 mt-1">
        Codice Fiscale non valido
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Cognome *</label>
      <input type="text" [(ngModel)]="cognome" name="cognome" #cognomeRef="ngModel" required
              [class.border-red-500]="cognomeRef.invalid && cognomeRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="cognomeRef.invalid && cognomeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Nome *</label>
      <input type="text" [(ngModel)]="nome" name="nome" #nomeRef="ngModel" required
              [class.border-red-500]="nomeRef.invalid && nomeRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="nomeRef.invalid && nomeRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
  </div>

  <div class="grid md:grid-cols-3 gap-4 mt-4">
    <div>
      <label class="block mb-1 font-medium">Data di nascita *</label>
      <input type="date" [(ngModel)]="dataNascita" name="dataNascita" #dataNascitaRef="ngModel" required
              [class.border-red-500]="dataNascitaRef.invalid && dataNascitaRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="dataNascitaRef.invalid && dataNascitaRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Comune di nascita *</label>
      <input type="text" [(ngModel)]="comuneNascita" name="comuneNascita" #comuneNascitaRef="ngModel" required
              [class.border-red-500]="comuneNascitaRef.invalid && comuneNascitaRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="comuneNascitaRef.invalid && comuneNascitaRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
    <div>
      <label class="block mb-1 font-medium">Genere *</label>
      <select [(ngModel)]="genere" name="genere" #genereRef="ngModel" required
              [class.border-red-500]="genereRef.invalid && genereRef.touched"
              class="w-full border rounded px-3 py-2">
        <option value="male">Maschile</option>
        <option value="female">Femminile</option>
      </select>
      <p *ngIf="genereRef.invalid && genereRef.touched" class="text-sm text-red-500 mt-1">
        Campo obbligatorio
      </p>
    </div>
  </div>

  <div class="grid md:grid-cols-3 gap-4 mt-4">
    <div class="md:col-span-2">
      <label class="block mb-1 font-medium">Email *</label>
      <input type="email" [(ngModel)]="email" name="email" required
              #emailRef="ngModel"
              pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              [class.border-red-500]="emailRef.invalid && emailRef.touched"
              class="w-full border rounded px-3 py-2" />
      <p *ngIf="emailRef.invalid && emailRef.touched" class="text-sm text-red-500 mt-1">
        Inserisci un'email valida (es. nome&#64;dominio.com)
      </p>
    </div>
    <div class="flex gap-2">
      <div class="w-1/4">
        <label class="block mb-1 font-medium">Prefisso *</label>
        <select [(ngModel)]="prefisso" name="prefisso" #prefissoRef="ngModel" required
                [class.border-red-500]="prefissoRef.invalid && prefissoRef.touched"
                class="w-full border rounded px-3 py-2">
          <option *ngFor="let p of prefissiInternazionali" [value]="p.value">
            {{ p.flag }} {{ p.value }}
          </option>
        </select>
        <p *ngIf="prefissoRef.invalid && prefissoRef.touched" class="text-sm text-red-500 mt-1">
          Campo obbligatorio
        </p>
      </div>
      <div class="flex-1">
        <label class="block mb-1 font-medium">Telefono *</label>
        <input type="tel" [(ngModel)]="telefono" name="telefono" #telefonoRef="ngModel"
                maxlength="15" pattern="^[0-9]{6,10}$"
                [class.border-red-500]="telefonoRef.invalid && telefonoRef.touched"
                class="w-full border rounded px-3 py-2" />
        <p>Importante: verrà inviato un codice SMS per confermare il contratto</p>
        <p *ngIf="telefonoRef.invalid && telefonoRef.touched" class="text-red-500 text-sm">
          Numero di telefono non valido
        </p>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <label class="block mb-1 font-medium">Indirizzo di residenza *</label>
    <input type="text" 
            id="autocompleteResidenza" 
            name="indirizzoCompletoResidenza"
            [(ngModel)]="indirizzoCompletoResidenza" 
            #indirizzoCompletoResidenzaRef="ngModel" 
            required
            [class.border-red-500]="!isValidIndirizzoResidenza() && indirizzoCompletoResidenzaRef.touched"
            placeholder="Via civico e città..." 
            class="w-full border rounded px-3 py-2" />
    <p *ngIf="!isValidIndirizzoResidenza() && indirizzoCompletoResidenzaRef.touched" class="text-sm text-red-500 mt-1">
      Inserire l'indirizzo completo di via, civico e città
    </p>
  </div>

  <div class="mt-6">
    <label class="inline-flex items-start gap-2">
        <input
          type="checkbox"
          [(ngModel)]="privacyConsenso"
          required
          name="privacyConsenso"
          #privacyRef="ngModel"
          class="mt-1 accent-blue-600"
        />
        <span class="text-gray-700">
          Dichiaro di aver preso visione dell'<a class="font-bold underline" href="/privacy-policy" target="_blank">informativa privacy</a> e di prestare il consenso per la comunicazione dei dati personali con le modalità indicate al PUNTO 1 per le finalità di stipula di polizze assicurative, la comunicazione dei dati personali agli altri soggetti competenti indicati al PUNTO 4 per lo svolgimento degli obblighi normativi previsti e di aver preso visione ed accettare il contenuto dei <a class="font-bold underline" href="/termini-condizioni" target="_blank">termini e condizioni</a>.
        </span>
      </label>
      <p *ngIf="privacyRef.invalid && privacyRef.touched" class="text-sm text-red-500 mt-1">
        Devi accettare per continuare
      </p>
  </div>
  <div>
    <label class="inline-flex items-start gap-2">
        <input
          type="checkbox"
          [(ngModel)]="marketingConsenso"
          name="marketingConsenso"
          class="mt-1 accent-blue-600"
        />
        <span class="text-gray-700">
          Dichiaro di aver preso visione dell'<a class="font-bold underline" href="/privacy-policy" target="_blank">informativa privacy</a> e di prestare il consenso per la comunicazione dei dati personali con le modalità indicate al PUNTO 1 per finalità di marketing.
        </span>
      </label>
  </div>
</div>
